import { GridColDef } from '@mui/x-data-grid';
import { ToggleSwitchOff, ToggleSwitchOn } from '../common/Icons';
import './index.css'


export const columns: GridColDef[] = [
  {
    field: 'username', headerName: 'Nombre de Usuario', flex: 250,
    renderCell: (params) => (
      <span className={params.api.getCellValue(params.id, 'enabled') === 'No' ? 'lighten-row' : ''}>{params.value}</span>

    )
  },
  {
    field: 'person_fullname', headerName: 'Persona', flex: 250,
    renderCell: (params: any) => (
      <span className={params.api.getCellValue(params.id, 'enabled') === 'No' ? 'lighten-row' : ''}>{params.value}</span>

    )
  },
  {
    field: 'profile_name', headerName: 'Perfil', flex: 180,
    renderCell: (params: any) => (
      <span className={params.api.getCellValue(params.id, 'enabled') === 'No' ? 'lighten-row' : ''}>{params.value}</span>

    )
  },
  {
    field: 'enabled', headerName: 'Habilitado', flex: 150,
    renderCell: (params) => (
      <span>
        {(params.value === 'true' ? <ToggleSwitchOn className='enabled-toggle-icon' /> : <ToggleSwitchOff className='disabled-toggle-icon' />)}
      </span>
    )
  },
  {
    field: 'created_date', headerName: 'Fecha de Creación', flex: 220,
    renderCell: (params) => (
      <span className={params.api.getCellValue(params.id, 'enabled') === 'No' ? 'lighten-row' : ''}>{params.value}</span>

    )
  },
  {
    field: 'last_login', headerName: 'Último Acceso', flex: 220,
    renderCell: (params) => (
      <span className={params.api.getCellValue(params.id, 'enabled') === 'No' ? 'lighten-row' : ''}>{params.value}</span>

    )
  },
]

export const handleDoubleClickRow = (event: any, setPersonId: any) => {
  setPersonId(event.row.id)
}
